import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import CustomerDashboard from "../../components/CustomerDashboard/CustomerDashboard";
import Langtrans from "../../components/Langtrans/Langtrans";
import Buttons from "../../components/Button/Button";
import InsertLinkOutlinedIcon from "@mui/icons-material/InsertLinkOutlined";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import tshirt from "../../assets/t-shirt-icon.png";
import Chart from "react-apexcharts";
import money from "../../assets/money.png";
import clock from "../../assets/clock.png";
import "./Dashboard.scss";
import React from "react";
import moment from "moment";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { API, graphqlOperation } from "aws-amplify";
import { getProductTable } from "../../graphql/queries";
import { CircularProgress } from "@mui/material";
import CopyToClipboard from "react-copy-to-clipboard";
import Snackbars from "../../components/Snackbar/Snackbar";
import { updateProductTable } from "../../graphql/mutations";
import "moment/locale/fr";

const CompaignDetail = () => {
  const { t } = useTranslation();
  moment.locale("fr");
  const history = useHistory();
  const location = useLocation();
  const isAdmin = location?.state?.isAdmin;
  const { id } = useParams();
  const [totOrder, setTotalOrder] = useState(0);
  const [data, setData] = useState({});
  const [options, setOptions] = useState({});
  const [series, setSeries] = useState([]);
  const [copied, setCopied] = useState(false);
  const [msg, setmsg] = useState("");
  const [stopCamp, setStopCamp] = useState(false);
  const [errMsg, seterrMsg] = useState("");
  const [isFront, setIsFront] = useState(true);
  const [shirtsdata3, setshirtdata3] = useState("");
  const [shirtsdata4, setshirtdata4] = useState("");

  const date = moment(data?.createdAt)
    .add(data?.days + 1, "days")
    .format("D MMMM");
  useEffect(() => {
    orderdata();
  }, [data]);

  let XAxisArray = [];
  let YAxisArray = [];
  const orderdata = () => {
    if (data?.createdAt) {
      for (let i = 0; i < data.days; i++) {
        XAxisArray.push(
          moment(data?.createdAt).add(i, "days").format("MMM Do YY")
        );
      }
    }

    if (data?.orders?.items.length) {
      let orders = data?.orders?.items
        .filter(
          (item, index) =>
            data.orders.items?.findIndex(
              (item1) =>
                moment(item1?.acceptedOn).format("L") ===
                moment(item?.acceptedOn).format("L")
            ) === index
        )
        .map((item) => ({
          ...item,
          quantity: data.orders.items
            ?.filter(
              (item1) =>
                moment(item1?.acceptedOn).format("L") ===
                moment(item?.acceptedOn).format("L")
            )
            ?.reduce((prev, curr) => (prev += Number(curr?.quantity)), 0),
        }));
      let YAxisArray = XAxisArray.map((item) => {
        let X = orders.find(
          (el) => item == moment(el.acceptedOn).format("MMM Do YY")
        );
        return X ? X.quantity : 0;
      });
      setOptions({
        stroke: {
          curve: "straight",
        },
        dataLabels: {
          enabled: true,
        },
        chart: {
          id: "basic-bar",
        },

        xaxis: {
          labels: {
            show: true,
            rotate: -45,
            rotateAlways: true,
          },
          categories: XAxisArray,
        },
        yaxis: {
          tickAmount: 1 + Number(Math.max(...YAxisArray)),
          title: {
            text: "No. of orders",
          },
          labels: {
            formatter(value) {
              return value.toFixed(0);
            },
          },
        },
      });
      // console.log("YAxisArray=>", 1 + Number(Math.max(...YAxisArray)));
      setSeries([
        {
          name: "No.of.Order",
          data: YAxisArray,
        },
      ]);
    }
  };

  useEffect(() => {
    if (series?.length > 0) {
      setTotalOrder(series[0]?.data?.reduce((x, y) => x + y));
    }
  }, [series]);

  useEffect(() => {
    if (copied) {
      setmsg("Copied");
      setTimeout(() => {
        setCopied(false);
        setmsg("");
      }, 1500);
    }
  }, [copied]);

  const fetchPreview = async () => {
    if (!id) {
      return;
    }
    try {
      const { data } = await API.graphql(
        graphqlOperation(getProductTable, { id: id })
      );
      setData(data?.getProductTable);
    } catch (er) {
      return er;
    }
  };
  useEffect(() => {
    fetchPreview();
    selShirt();
  }, []);

  const remainDate = (createdAt, days) => {
    const currentDate = moment(createdAt, "YYYY-MM-DD");
    const futureDate = moment(currentDate._d).add(days, "days");
    const endDate = moment(futureDate._d).format("YYYY-MM-DD");
    const todaysdate = moment();
    return moment(endDate).diff(todaysdate, "days");
  };

  function toDataURL(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.onload = function () {
      var reader = new FileReader();
      reader.onloadend = function () {
        callback(reader.result);
      };
      reader.readAsDataURL(xhr.response);
    };
    url += "?" + new Date().getTime();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.send();
  }

  const selShirt = async (data) => {
    await toDataURL(data?.shirtDesignFront, async function (myBase64) {
      setshirtdata3(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
    await toDataURL(data?.shirtDesignBack, async function (myBase64) {
      setshirtdata4(
        myBase64 &&
          myBase64.replace(
            "data:binary/octet-stream;base64,",
            "data:image/png;base64,"
          )
      );
    });
  };

  if (!data) {
    return (
      <div className="loading">
        <CircularProgress />
      </div>
    );
  }

  const stop = async () => {
    setStopCamp(true);
    try {
      API.patch("laetusapi", "/api/v1/updateproduct", {
        body: {
          show_on_shop: data.isStop ? true : false,
          id: data.weflowProductId,
        },
      })
        .then(async (res) => {
          const data1 = await API.graphql(
            graphqlOperation(updateProductTable, {
              input: {
                isStop: !data.isStop ? true : false,
                id: data.id,
              },
            })
          );
          setmsg(!data.isStop ? t("stop-campaign") : t("resume-campaign"));
          setStopCamp(false);
          setData(data1.data.updateProductTable);
          setTimeout(() => {
            setmsg("");
          }, 1500);
        })
        .catch(() => {
          setStopCamp(false);
        });
    } catch (error) {
      seterrMsg(error.message);
      setStopCamp(false);
    }
  };

  const handleWebflow = () => {
    const win = window.open(`http://${data.weflowProductURL}`, "_blank");
    win.focus();
  };
  // console.log("series==>", series);

  return (
    <>
      <div className="home">
        {!isAdmin ? (
          <div className="left">
            <CustomerDashboard />
          </div>
        ) : null}
        <div className={`${"right"} ${isAdmin && "adminRight"}`}>
          <div className="top" style={{ marginTop: "10px" }}>
            <div className="page-heading">
              <h3 onClick={() => history.goBack()} className="cp">
                &#60; {data.shirtName}
              </h3>

              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "14px",
                  color: "#b3b3b3",
                  marginLeft: "-5px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                  onClick={() => handleWebflow()}
                  className="cp"
                >
                  <div>
                    <OpenInNewIcon className="svg_icons" />
                  </div>
                  <div
                    style={{
                      marginTop: "3px",
                    }}
                  >
                    {t("countryside")}
                  </div>
                </div>
                <CopyToClipboard
                  text={data.weflowProductURL}
                  onCopy={() => setCopied(true)}
                  className="cp"
                  fontSize="small"
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      marginLeft: "5px",
                    }}
                  >
                    <div>
                      <InsertLinkOutlinedIcon className="svg_icon" />
                    </div>
                    <div
                      style={{
                        marginTop: "3px",
                      }}
                    >
                      {t("copy-link")}
                    </div>
                    <input
                      type="text"
                      value={data.weflowProductURL}
                      hidden
                      disabled
                    />
                  </div>
                </CopyToClipboard>
              </div>

              <p style={{ marginTop: "5px" }}>
                {remainDate(data.createdAt, data.days) < 0 + 1
                  ? 0 + t("days-remain")
                  : remainDate(data.createdAt, data.days) +
                    1 +
                    t("days-remain")}
              </p>
              <Buttons
                className="btns"
                text={
                  remainDate(data.createdAt, data.days) + 1 === 0 ||
                  remainDate(data.createdAt, data.days) + 1 < 0 ||
                  data.isStop
                    ? t("terminate")
                    : t("progress")
                }
              />
            </div>
            <div style={{ marginLeft: "-100px" }} className={"imgChange"}>
              <img
                src={isFront ? data.designShirt : data.designShirtBack}
                width={170}
                height={150}
                rel="noopener noreferrer"
                alt="front shirt"
              />
              <Buttons
                text={isFront ? t("see_bck_img") : t("see_frt_img")}
                onClick={() => setIsFront((prev) => !prev)}
              />
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-50px",
              }}
            >
              <div>
                {!isAdmin && (
                  <div
                    style={{ display: "flex", alignItems: "center" }}
                    // onClick={() => history.push(`/donepreview/${id}`)}
                    onClick={() => handleWebflow()}
                  >
                    <Buttons
                      style={{
                        width: "190px",
                        marginLeft: "3px",
                        background: "#000",
                        marginRight: "10px",
                      }}
                      text={t("countryside")}
                      icon={<VisibilityOutlinedIcon />}
                    />
                    <Langtrans
                      dashboard
                      style={{
                        marginRight: "0px",
                        marginTop: "0px",
                        height: "36px",
                      }}
                    />
                  </div>
                )}
                {!isAdmin && (
                  <div>
                    <p
                      style={{
                        textDecoration: "underline",
                        textAlign: "left",
                        marginLeft: "30px",
                      }}
                      className="cp"
                      onClick={() => stop()}
                    >
                      {stopCamp ? (
                        <CircularProgress
                          size="20px"
                          color="inherit"
                          style={{ textAlign: "center" }}
                        />
                      ) : data.isStop ? (
                        t("resume_campaign")
                      ) : (
                        t("stop")
                      )}
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="bottom">
            <hr />
            <div className="bottom-top">
              <div
                className="card"
                style={{ height: "210px", paddingTop: "20px" }}
              >
                <div className="cal-div">
                  <div className="shirt-div">
                    <img src={tshirt} width={50} height={50} />
                    <h2>{totOrder}</h2>
                    <p>
                      <b>{t("pre-order")}</b>
                    </p>
                    <small>{t("need-preorders")}</small>
                  </div>
                  <div className="shirt-div">
                    <img src={money} width={50} height={50} />
                    {/* {console.log("data==>", data)} */}
                    <h2>{totOrder * (data.sellingPrice - data.realprice)}€</h2>
                    <p>
                      <b>{t("potential")}</b>
                    </p>
                    <small>{t("need-preorders")}</small>
                  </div>
                  <div className="shirt-div">
                    <img src={clock} width={50} height={50} />
                    <h2>
                      {" "}
                      {remainDate(data.createdAt, data.days) < 0 + 1
                        ? 0
                        : remainDate(data.createdAt, data.days) + 1}
                    </h2>
                    <p>
                      <b>{t("remains-day")}</b>
                    </p>
                    <small>
                      {t("delivery")} {date}
                    </small>
                  </div>
                </div>
              </div>
            </div>
            <div className="chart">
              <h2>{t("per-day-order")}</h2>
              <Chart
                options={options}
                series={series}
                type="line"
                width="100%"
                height="500px"
              />
            </div>
          </div>
        </div>
      </div>
      {copied && <Snackbars message={msg} />}
      {msg || errMsg ? <Snackbars message={msg} errMessage={errMsg} /> : null}
    </>
  );
};
export default CompaignDetail;
